
export default {
    name: 'IconOrder',
    props: {
        width: {
            type: String,
            default: '24px'
        },
        height: {
            type: String,
            default: '24px'
        },
        color: {
            type: String,
            default: '#303030'
        }
    }
}
